import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef, NbDialogService, NbMenuItem } from "@nebular/theme";

@Component({
  selector: "ngx-dialog-profile",
  templateUrl: "dialog-profile.component.html",
  styleUrls: ["dialog-profile.component.scss"],
})
export class DialogProfileComponent implements OnInit {
  @Input() header?: string;
  @Input() courseId?: string = "";
  @Input() userId?: string = "";

  submitted = false;
  loading = false;
  loadingProfile = false;

  constructor(protected ref: NbDialogRef<DialogProfileComponent>) {}

  ngOnInit() {}

  close() {
    this.ref.close();
  }
}
